import { render, staticRenderFns } from "./CustomVColInfo.vue?vue&type=template&id=a85d2aa6&"
import script from "./CustomVColInfo.vue?vue&type=script&lang=ts&"
export * from "./CustomVColInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/claude-1000/-home-twyngo-dev-projeta-lims-front-portal/d9e4e7d1-f8c4-4277-9ce4-f099f22133b1/scratchpad/build-front-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../tmp/claude-1000/-home-twyngo-dev-projeta-lims-front-portal/d9e4e7d1-f8c4-4277-9ce4-f099f22133b1/scratchpad/build-front-portal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
